"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const ModalContent_module_scss_1 = __importDefault(require("./ModalContent.module.scss"));
/**
 * ModalContent is for composing the contents of the modal
 * receives main, content and footer to slot the components in
 *
 * @param {object} props
 * @param {string} props.classes - classes for the container of the modal content
 * @param {string} props.mainClasses - classes for the container for main content (featured, aka, where image, title, description price is in base design)
 * @param {string} props.contentClasses - classes for the container for the detailed content
 * @param {string} props.footerClasses - classes for the footer container, the footer is rendered at the bottom of the details content container
 * @param {import('react').ReactNode} props.main - react node for the featured section in modal
 * @param {import('react').ReactNode} props.content - react node for the content section
 * @param {import('react').ReactNode} props.footer - react node for footer, its optional
 */
const ModalContent = ({ classes, mainClasses, contentClasses, footerClasses, main, content, footer }) => {
    const ref = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        var _a;
        return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
    }, []);
    const modalContentClasses = (0, classnames_1.default)(ModalContent_module_scss_1.default.container, classes);
    const mainClassNames = (0, classnames_1.default)(ModalContent_module_scss_1.default.main, mainClasses);
    const contentClassNames = (0, classnames_1.default)(ModalContent_module_scss_1.default.content, contentClasses);
    const footerClassNames = (0, classnames_1.default)(ModalContent_module_scss_1.default.footer, footerClasses);
    return (0, jsx_runtime_1.jsxs)("div", { ref: ref, className: modalContentClasses, children: [(0, jsx_runtime_1.jsx)("div", { className: mainClassNames, children: main }), (0, jsx_runtime_1.jsxs)("div", { className: contentClassNames, children: [content, footer && (0, jsx_runtime_1.jsx)("footer", { className: footerClassNames, children: footer })] })] });
};
ModalContent.propTypes = {
    /** style overrides for the parent div */
    classes: prop_types_1.default.string,
    /** style overrides for the featured container div */
    mainClasses: prop_types_1.default.string,
    /** style overrides for the details container div */
    contentClasses: prop_types_1.default.string,
    /** style overrides for the footer container div, its rendered inside content div */
    footerClasses: prop_types_1.default.string,
    /** Main corresponds to the section where the picture would normally be */
    main: prop_types_1.default.node.isRequired,
    /** Content corresponds to the feature list, buttons buystack etc */
    content: prop_types_1.default.node.isRequired,
    /** Footer is a section appended to in the content section at the bottom */
    footer: prop_types_1.default.node,
};
exports.default = ModalContent;
//# sourceMappingURL=ModalContent.js.map